import { render, staticRenderFns } from "./DesktopTabs.vue?vue&type=template&id=3842f5be&"
import script from "./DesktopTabs.vue?vue&type=script&lang=js&"
export * from "./DesktopTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports